// escalation-blocked-by.ts
//
// WHY a ticket stopped (blocked / escalate_waiting_human), set AT the decision
// point and journaled as `attempt_finished.blocked_by`. Never inferred later
// from `reason` text: counted cap and a worker-declared `blocked` both end
// `blocked`/`task_failed`; timeout split, infra and outage all end
// `escalate_waiting_human` — only this tag tells them apart.
export const BLOCKED_BY_VALUES = [
  "counted_cap",
  "worker_declared",
  "timeout_split",
  "infra",
  "outage",
  "governance",
  "policy_deny",
  "self_amend",
  "g0_claim",
  "other",
] as const;

export type BlockedBy = (typeof BLOCKED_BY_VALUES)[number];

/** Journal value → BlockedBy; a value this CLI does not know reads as `other` (fail closed). */
export function parseBlockedBy(value: unknown): BlockedBy {
  return (BLOCKED_BY_VALUES as readonly unknown[]).includes(value) ? (value as BlockedBy) : "other";
}

/** Re-tag a STOP decision with the branch's own cause; a `retry` stays untagged. */
export function tagStopDecision<T extends { outcome: string; blocked_by?: BlockedBy }>(
  decision: T,
  blockedBy: BlockedBy,
): T {
  return decision.outcome === "retry" ? decision : { ...decision, blocked_by: blockedBy };
}
